import { AppSubjectEnum } from '../../authz/enums/app-subject.enum';
import { CaslSubject } from '../../authz/decorators/casl-subject.decorator';
import { BaseStatsDto } from '../../base/dtos/base-stats.dto';

/**
 * Vehicle models stats DTO
 */
@CaslSubject(AppSubjectEnum.VEHICLE)
export class VehicleModelsStatsDto extends BaseStatsDto {
}
